import listFieldFilterTypeRegistry from "sulu-admin-bundle/containers/List/registries/listFieldFilterTypeRegistry.js";

import SingleDateField from "./SingleDateField/SingleDateField";

const registeredListFields = () => {
    listFieldFilterTypeRegistry.add("single_date", SingleDateField);
};

export default registeredListFields;
